"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipBodyStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _tooltipTheme = require("../tooltipTheme");
const TooltipBodyStyled = (0, _styled.default)("div")`
    padding: var(--sds--tooltip--padding, ${_ref => {
  let {
    themeMode
  } = _ref;
  return _tooltipTheme.tooltipTheme.padding.body(themeMode);
}});

    // These are set to ensure the arrow calculations don't create an infinite loop due. See #468.
    min-height: 8px;
    min-width: 8px;

    *,
    a {
        color: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return `var(--sds--tooltip--text-color, ${_tooltipTheme.tooltipTheme.textColor.title(themeMode)})`;
}};
    }
`;
exports.TooltipBodyStyled = TooltipBodyStyled;
//# sourceMappingURL=TooltipBodyStyled.js.map